{
  "collapse": "Sažmi",
  "expand": "Proširi"
}
